import { render } from "./QrCodePage.vue?vue&type=template&id=506cb8c8"
import script from "./QrCodePage.vue?vue&type=script&lang=js"
export * from "./QrCodePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__